<template>
  <div>
    <contract-file :contract-id="contractId" :is-init="true" />
  </div>
</template>

<script>
import contractFile from './file.vue';
export default {
  data () {
    return {
      contractId: ''
    };
  },
  components: {
    contractFile
  },
  mounted () {
    this.contractId = this.$route.query.contractId;
  }
};
</script>

<style>

</style>
